import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "thumbnail", "counter", "arrowLeft", "arrowRight"]
  static values = { currentIndex: Number }

  connect() {
    this.totalImages = this.mainImageTargets.length
    this.isTransitioning = false
    if (typeof this.currentIndexValue === 'undefined') this.currentIndexValue = 0
    if (this.totalImages > 1) {
      if (this.hasArrowLeftTarget) this.arrowLeftTarget.classList.remove("invisible")
      if (this.hasArrowRightTarget) this.arrowRightTarget.classList.remove("invisible")
    }
    this.updateGallery()
  }

  next() {
    if (this.currentIndexValue < this.totalImages - 1 && !this.isTransitioning) {
      this.slideTo(this.currentIndexValue, this.currentIndexValue + 1, "left")
    }
  }
  previous() {
    if (this.currentIndexValue > 0 && !this.isTransitioning) {
      this.slideTo(this.currentIndexValue, this.currentIndexValue - 1, "right")
    }
  }
  selectImage(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    if (!this.isTransitioning && index !== this.currentIndexValue) {
      const dir = index > this.currentIndexValue ? "left" : "right"
      this.slideTo(this.currentIndexValue, index, dir)
    }
  }

  updateGallery() {
    this.mainImageTargets.forEach((image, index) => {
      image.classList.remove("absolute", "inset-0", "z-20", "z-10", "transition-all", "duration-300", "translate-x-0", "translate-x-full", "-translate-x-full")
      if (index === this.currentIndexValue) {
        image.classList.remove("hidden")
      } else {
        image.classList.add("hidden")
      }
    })
    this.thumbnailTargets.forEach((thumbnail, index) => {
      if (index === this.currentIndexValue) {
        thumbnail.classList.remove("border-gray-200", "hover:border-blue-400", "ring-0")
        thumbnail.classList.add("border-blue-600", "ring-2", "ring-blue-200")
      } else {
        thumbnail.classList.remove("border-blue-600", "ring-2", "ring-blue-200")
        thumbnail.classList.add("border-gray-200", "hover:border-blue-400", "ring-0")
      }
    })
    if (this.hasCounterTarget) this.counterTarget.textContent = this.currentIndexValue + 1
    if (this.hasArrowLeftTarget) {
      this.arrowLeftTarget.classList.toggle("invisible", this.currentIndexValue === 0)
    }
    if (this.hasArrowRightTarget) {
      this.arrowRightTarget.classList.toggle("invisible", this.currentIndexValue === this.totalImages - 1)
    }
  }

  slideTo(from, to, direction) {
    this.isTransitioning = true
    const fromImg = this.mainImageTargets[from], toImg = this.mainImageTargets[to]
    if (this.hasArrowLeftTarget) {
      this.arrowLeftTarget.classList.toggle("invisible", to === 0)
    }
    if (this.hasArrowRightTarget) {
      this.arrowRightTarget.classList.toggle("invisible", to === this.totalImages - 1)
    }
    fromImg.classList.remove("hidden")
    toImg.classList.remove("hidden")
    fromImg.classList.add("absolute", "inset-0", "z-20", "transition-all", "duration-300")
    toImg.classList.add("absolute", "inset-0", "z-10", "transition-all", "duration-300")
    fromImg.classList.remove("translate-x-0", "-translate-x-full", "translate-x-full")
    toImg.classList.remove("translate-x-0", "-translate-x-full", "translate-x-full")
    if (direction === "left") {
      toImg.classList.add("translate-x-full")
      setTimeout(() => {
        toImg.classList.remove("translate-x-full")
        toImg.classList.add("translate-x-0")
        fromImg.classList.add("-translate-x-full")
      }, 20)
    } else {
      toImg.classList.add("-translate-x-full")
      setTimeout(() => {
        toImg.classList.remove("-translate-x-full")
        toImg.classList.add("translate-x-0")
        fromImg.classList.add("translate-x-full")
      }, 20)
    }
    setTimeout(() => {
      fromImg.classList.remove("absolute", "inset-0", "z-20", "transition-all", "duration-300", "translate-x-full", "-translate-x-full", "translate-x-0")
      fromImg.classList.add("hidden")
      toImg.classList.remove("absolute", "inset-0", "z-10", "transition-all", "duration-300", "translate-x-full", "-translate-x-full")
      this.currentIndexValue = to
      this.isTransitioning = false
      this.updateGallery()
    }, 330)
  }

  currentIndexValueChanged() {
    this.updateGallery()
  }
}